<template>
  <b-row align-content="center" class="py-2">
    <b-col cols="12" align-self="center" class="justify-content-center">
      <b-row align-content="center" class="justify-content-center">
        <b-col
          :cols="handleStepperCols"
          align-self="center"
          class="d-flex justify-content-center px-1"
          v-for="(key, i) in steppers"
          :key="i"
        >
          <div
            :key="key"
            class="stepper-line"
            :class="{ 'stepper-line-active': i === handleStepperPage - 1 }"
          ></div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "shetabStepperNewVersion",
  data() {
    return {
      steppers: [1, 2, 3, 4],
    };
  },

  computed: {
    ...mapGetters(["getStepperPage", "getIsCompName"]),
    handleStepperPage() {
      switch (this.getStepperPage) {
        case "pageOne":
          return 1;
        case "pageTwo":
          return 2;
        case "pageThree":
          return 3;
        case "pageFour":
          return 4;
        default:
          return 1;
      }
    },
    handleStepperCols() {
      switch (this.getIsCompName) {
        case "shetab":
          return 3;
        case "perfectMoney":
          return 12;
        case "tether":
        case "cardToCard":
          return 5;
        case "shaparak":
          return 4;
        default:
          return 3;
      }
    },
  },
  methods: {
    handleStepperLength() {
      switch (this.getIsCompName) {
        case "shetab":
          return (this.steppers = [1, 2, 3, 4]);
        case "perfectMoney":
          return (this.steppers = [1]);
        case "cardToCard":
        case "tether":
          return (this.steppers = [1, 2]);
        case "shaparak":
          return (this.steppers = [1, 2, 3]);
        default:
          return (this.steppers = [1, 2, 3, 4]);
      }
    },
  },
  created() {
    this.handleStepperLength();
  },
};
</script>

<style scoped>
.stepper-line {
  width: 100%;
  height: 5px;
  border-radius: 10px;
  border: 1px solid lightgrey;
  background-color: lightgrey;
}
.stepper-line-active {
  background-color: #bcdcfc !important;
}
</style>
